// @ts-nocheck c456fb54
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_FWline'],
      sections: [
        addPanel.sections.getSections().vectorShape.fullWidthLinesSection,
      ],
    };
  },
};
